import React, { useState, useEffect } from 'react';
import AuthCode from 'react-auth-code-input';
import { postReq } from '../../utils/api';
import './index.scss';
import { DOMAIN } from '../../Constants/base';
export default function OtpComponent(props) {
  const { otp, email, setOtp, setCurrentStep, setUserJwtToken, isSignUp } = props;

  const [errorOtp, setOtpError] = useState('');

  useEffect(() => {
    if (otp.length === 5) {
      handleOtpVerification();
    }
  }, [otp]);

  const handleOtpVerification = async () => {
    let url = `${DOMAIN}/v1/user/v2/login`;
    let payload = {
      email: email,
      otp: parseInt(otp),
    };

    const verificationResp = await postReq({ url, payload });
    const { code, data, message } = verificationResp;
    if (code === 200) {
      if (isSignUp) {
        setCurrentStep((prev) => prev + 1);
        setUserJwtToken(data.accessToken);
      } else {
        localStorage.setItem('ss-auth-sales', JSON.stringify(data.accessToken));
        window.location = '/';
      }
      // getOptions(data.accessToken);
    } else if (code !== 200 && message) {
      setOtpError(message);
    } else if (code !== 200 && !message) {
      setOtpError('Oops! Something went wrong, please contact us!');
    }
    setOtp('');
  };

  return (
    <div className="otp">
      <div className="otp__title">
        We’ve sent you a verification code to <span>{email}</span>
      </div>
      <div>
        <AuthCode
          containerClassName="otp-container"
          inputClassName="otp-input"
          length={5}
          allowedCharacters="numeric"
          onChange={(ot) => {
            if (ot.length && errorOtp) setOtpError('');
            setOtp(ot);
          }}
        />
      </div>
      {errorOtp?.length > 0 ? <div className="error-message">{errorOtp}</div> : null}
      <div className="otp-content">
        If you are having trouble finding the verification email in your <span>INBOX</span> please also check the{' '}
        <span>SPAM</span> folder in case it might have ended up there by mistake
      </div>
    </div>
  );
}
